var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContent"},[_c('PageHeader'),_c('div',{staticClass:"pageMain"},[_c('router-view')],1),_c('PageFooter',{staticClass:"pageFooter-wrap"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }